// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"i--z"};